export const ProjectCommon = {
  debug: false,
  api: 'https://api.siteassist.co/api/',
  nestApi: 'https://internal-api.prod.siteassist.co/nest-api/',
  apiBaseUrl: 'https://api.siteassist.co/',
  appUrl: 'https://app.siteassist.co',
  toolboxUrl: 'https://api.siteassist.co/toolbox/',
  flagsmith: 'N4YCCJMHVwdQGpZtauqx4Z',
  bugsnag: '7fe4e26292804f394b2e11d9d2c918ae',
  intercomAppId: 'd1ld00v1',
  airtableToken:
    'patfHXJ9kFBc3okoD.01f744f845543e9fc9dba245fb8aa8485382ea598140fb3eab3b73a94b18a2e6',
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_eoRHE2b5K',
    userPoolWebClientId: '7r3283ra2kv4vr8evj2287vk9p',
  },
  cognitoMobile: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_eoRHE2b5K',
    userPoolWebClientId: '6ne75nh636nj0brnsdl4bkn5bp',
  },
  logs: {
    DATA: false,
    STORE: false,
    DISPATCHER: false,
    STORAGE: false,
    SERVER: false,
  },
  mobile: {
    // Enabling secured storage for mobile requires installation of https://www.npmjs.com/package/react-native-secured-storage. See README for further instructions on installation
    useSecuredStorage: false,
  },
  gitHash: '34beb89802',
  mapBox: {
    web: 'pk.eyJ1Ijoic2l0ZWFzc2lzdCIsImEiOiJjbDgzNHVwdGMwMjc3M3dwZnd0NDh4NGtzIn0.67oZZ7f1U7Kizmjj7Ikr4g',
    mobile:
      'pk.eyJ1Ijoic2l0ZWFzc2lzdCIsImEiOiJjbHZwNzlrN3cwcTI4MmltZ2Y0czQzY3c3In0.ctW42MwFUdrDq0QCIHXbUg',
  },
  w3wKey: 'YR9Q1GSS',
  appleAppStoreUrl: 'https://apps.apple.com/app/site-assist/id1554478779',
  googlePlayStoreUrl:
    'https://play.google.com/store/apps/details?id=co.siteassist.mobile',
  segmentWriteKey: 'ujE6f9z8KDHD4FPbnswO9d1nGqebneyU',
  pusherKey: 'b1a9acd80af99ebdda1f',
}
